import "./src/styles/fonts.css"
import "./src/styles/global.css"
import "./src/styles/components.css"
import {
  initPageviewAnalytics,
  trackPageView,
} from "./src/utils/analytics"
import {
  scrollToTopOnRouteUpdate,
  shouldUpdateScroll,
} from "./src/utils/scroll-restoration"
import { redirectLegacyWordPressSearch } from "./src/utils/legacySearchRedirect"
import { initYouTubeFacades } from "./src/utils/youtubeFacade"

export { shouldUpdateScroll }

export const onClientEntry = (): void => {
  redirectLegacyWordPressSearch()
  initPageviewAnalytics()
}

const pagePathFromLocation = (location: Location): string  => {
  return location.pathname + location.search + location.hash
}

const schedulePageView = (location: Location): void  => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      trackPageView(
        pagePathFromLocation(location),
        typeof document !== "undefined" ? document.title : undefined
      )
    })
  })
}

export const onInitialClientRender = (): void => {
  if (typeof window !== "undefined") {
    initYouTubeFacades()
    schedulePageView(window.location)
  }
}

export const onRouteUpdate = ({
  location,
  prevLocation,
}: {
  location: Location
  prevLocation: Location | null
}): void => {
  initYouTubeFacades()

  if (!prevLocation) {
    return
  }

  scrollToTopOnRouteUpdate({ location, prevLocation })
  schedulePageView(location)
}
